import { Route, Routes } from "react-router-dom";
import { isBrowser, isMobile } from "react-device-detect";
import BrowserMainPage from "./components/BrowserView/Pages/BrowserMainPage";
import MobileMainPage from "./components/MobileView/Pages/MobileMainPage";
import NotFound from "./components/NotFound/NotFound";
import "./index.css";

function App() {
 const getView = () => {
  if (isBrowser) {
   return <BrowserMainPage />;
  } else if (isMobile) {
   return <MobileMainPage />;
  } else {
   return <NotFound />;
  }
 };

 return (
  <div className="App">
   <Routes>
    <Route exact path="/" element={getView()} />
    <Route path="*" element={<NotFound />} />
   </Routes>
  </div>
 );
}

export default App;
